(() => {
    let d, a = e => {
            var s, t, i, r = (slider = e.querySelector(".js-slider-testimonials")).parentNode.querySelector(".swiper-button-prev"),
                n = slider.parentNode.querySelector(".swiper-button-next");
            slider && (t = (s = Number(slider.dataset.columns)) < 2 ? 1.2 : 2, i = s < 3 ? s : 3, d = new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 24,
                speed: 800,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
                mousewheel: {
                    forceToAxis: !0
                },
                navigation: {
                    prevEl: r,
                    nextEl: n
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.4,
                        spaceBetween: 24,
                        // centeredSlides: true,
                        loop: true,
                    },
                    750: {
                        slidesPerView: t,
                        spaceBetween: 24
                    },
                    990: {
                        slidesPerView: t,
                        spaceBetween: 24
                    },
                    1200: {
                        slidesPerView: i,
                        spaceBetween: 32
                    },
                    1360: {
                        slidesPerView: s,
                        spaceBetween: 32
                    },
                    1600: {
                        slidesPerView: s,
                        spaceBetween: 48
                    },
                    1904: {
                        slidesPerView: s,
                        spaceBetween: 48
                    }
                }
            }));
            let l = () => {
                    d && (d.destroy(!0, !0), d = null), window.removeEventListener("resize", o)
                },
                o = () => {
                    l(), a(e)
                };
            window.addEventListener("resize", o)
        },
        s = s => {
            s && s.classList.contains("section-testimonials-list") && new IntersectionObserver(e => {
                e.forEach(e => {
                    e.isIntersecting && a(s)
                })
            }).observe(s)
        };
    s(document.currentScript.parentElement), document.addEventListener("shopify:section:load", function(e) {
        s(e.target)
    })
})();